const common = {

}

const development = {
    api : {
        // old base: 'http://app.assimilate.com:3030'
        base: 'https://3dstest.abcorp.com/api'
    },
    recaptcha: {
        key: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI'
    },
    storage: {
        host: "https://3dstest.abcorp.com/api"
    },
    style: {
        bg_color: "bg-green-200"
    }
}

const production = {
    api: {
        base: 'https://3ds.abcorp.com/api'
    },
    recaptcha: {
        key: '6LcIggUsAAAAADneFNtJ3Uu-fgLPELVlPC0CsjNY'
    },
    storage: {
        host: "https://3ds.abcorp.com/api"
    },
    style: {
        bg_color: ""
    }
}

var config = {};
switch(process.env.REACT_APP_ENV) {

    case "production":
        config = {...common, ...production};
        break;

    case "development":
        config = {...common, ...development};
        break;

    default:
        break;
}

export default config;